import wineList from "../assets/Beer - Wine Menu.jpg";
import "./styles.css";

function WineList() {
  return (
    <div>
      <div className="about-page">
        <section className="about-hero">
          <h1>Our Wine List</h1>
        </section>
      </div>
      <div>
        <section className="menu-section">
          <div>
            <img src={wineList} alt="Wine List" />
          </div>
        </section>
      </div>
    </div>
  );
}

export default WineList;
